import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  shapeType: "多级导航",
  value: "选中值",
  selectOptions: "多级导航选项",
  // bgColor: "背景颜色",
  // borderStyle: "边框类型", // solid dashed dotted
  // borderColor: "边框颜色",
  // borderWidth: "边框宽度",
  // borderIsThemeColor: "边框颜色为主题色",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",

  "boxShadowColor.0": "阴影颜色1"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
